// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import {
  IS_PORTAL,
  jewlr_t,
  IS_GE_CHECKOUT,
  IS_UK,
  IS_AU,
} from "helpers/application"
import { cn } from "styles/utils"

const ShipMethod = ({ className = "", ...props }) => (
  <p className={cn("text-14 font-medium text-black", className)} {...props} />
)

const LineItemShipping = ({ item }) => {
  // const forHer = item.product_gender === "female"
  const is_ge_checkout = IS_GE_CHECKOUT()
  const is_uk_or_au = IS_AU() || IS_UK()

  return (
    <div className="text-14 leading-18 desktop:mt-24 my-16">
      {item.holiday_availability && (
        <Media className="mb-4" greaterThanOrEqual="tablet">
          <div className="text-ruby flex items-center">
            <FontAwesomeIcon className="mr-4" icon={faGift} />
            <p className="text-16 font-semibold">
              Arrives Before{" "}
              {sl.config.guaranteed_holiday_alias ||
                sl.config.guaranteed_holiday}
            </p>
          </div>
        </Media>
      )}
      {(!is_ge_checkout || is_uk_or_au) &&
      item.delivery_dates &&
      item.delivery_dates.length > 0 ? (
        item.delivery_dates.map((d) => (
          <ShipMethod
            className={cn(
              d.type.includes(IS_PORTAL() ? "Standard" : "FREE")
                ? "text-black"
                : "text-emerald"
            )}
            data-cy={`itemShipping-${d.type}`}
            key={`itemShipping-${d.type}`}
          >
            <span className="font-semibold">{d.type}</span>{" "}
            {!d.date_range?.length > 0 && (
              <span className="italic">{d.date}</span>
            )}
            {d.date_range?.length > 0 && (
              <>
                <span className="italic">{d.date_range[0]}</span> to{" "}
                <span className="italic">{d.date_range[1]}</span>
              </>
            )}
          </ShipMethod>
        ))
      ) : item.delivery_date_range ? (
        <ShipMethod>
          {IS_PORTAL() ? "Standard" : "Free"} {jewlr_t("terms.Shipping")}{" "}
          <span className="italic">
            {item.delivery_date_range[0]}-{item.delivery_date_range[1]}
          </span>
        </ShipMethod>
      ) : (
        <ShipMethod>
          Ships by <span className="italic">{item.est_ship_date}</span>
        </ShipMethod>
      )}
    </div>
  )
}

LineItemShipping.propTypes = {
  item: PropTypes.object,
}
ShipMethod.propTypes = {
  className: PropTypes.string,
}
export default LineItemShipping
